import React from 'react';

// Placeholder Logo component removed for branding
const Logo = () => null;
export default Logo;
